import {
    TestsheetListingResponse,
    TestsheetModel,
    TestsheetStatus,
    useGetTestsheetsListingMutation,
    useGetTestsheetsMutation
} from '@services';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useTestsheetsPageVM = () => {
    const [testsheetsListing, setTestsheetsListing] = useState<TestsheetListingResponse>([]);
    const [testsheets, setTestsheets] = useState<Array<TestsheetModel>>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [getTestsheetsListing, { isLoading: isLoadingTestsheets, error: errorTestsheets, data: dataTestsheets }] =
        useGetTestsheetsListingMutation();
    const [getTestsheets, { isLoading: isLoadingTestsheetsQuiz, error: errorTestsheetsQuiz, data: dataTestsheetsQuiz }] =
        useGetTestsheetsMutation();

    const navigate = useNavigate();

    useEffect(() => {
        getTestsheetsListing();
        getTestsheets();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (errorTestsheets) {
            console.error(errorTestsheets);
        }
        if (dataTestsheets) {
            setTestsheetsListing(dataTestsheets);
        }
    }, [errorTestsheets, dataTestsheets]);

    useEffect(() => {
        if (errorTestsheetsQuiz) {
            console.error(errorTestsheetsQuiz);
        }
        if (dataTestsheetsQuiz) {
            setTestsheets(dataTestsheetsQuiz);
        }
    }, [errorTestsheetsQuiz, dataTestsheetsQuiz]);

    const waitingTestsheets = testsheetsListing.filter((testsheet) => testsheet.status === TestsheetStatus.TO_VALIDATE);
    const validatedTestsheets = testsheetsListing.filter((testsheet) => testsheet.status === TestsheetStatus.ARCHIVED);

    return {
        isLoading: isLoadingTestsheets || isLoadingTestsheetsQuiz,
        errorTestsheets,
        waitingTestsheets,
        validatedTestsheets,
        testsheets,
        navigate,
        isModalOpen,
        setIsModalOpen
    };
};
